import { Users, TerminalIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type LiveConsoleHeaderProps = {
    isPlayerListOpen: boolean;
    setIsPlayerListOpen: (open: boolean) => void;
    playerCount: number;
    isConnected: boolean;
};

export default function LiveConsoleHeader({
    isPlayerListOpen,
    setIsPlayerListOpen,
    playerCount,
    isConnected,
}: LiveConsoleHeaderProps) {
    return (
        <div className="flex items-center justify-between px-4 py-2.5 border-b border-white/[0.05] bg-[#030507]/95 backdrop-blur-sm select-none shrink-0">
            {/* Left — status + title */}
            <div className="flex items-center gap-3">
                {/* connection pulse */}

                <div className="flex items-center gap-2">
                    <TerminalIcon
                        size={14}
                        className={cn(isConnected ? "text-[#00ffd1]" : "text-destructive")}
                    />
                    <span className="font-mono text-sm font-semibold tracking-wider text-slate-100">
                        Live Console
                    </span>
                    <span className={cn(
                        "text-[9px] font-bold px-1.5 py-0.5 rounded font-mono uppercase tracking-widest border",
                        isConnected
                            ? "bg-[#00ff66]/5 border-[#00ff66]/20 text-[#00ff66]"
                            : "bg-destructive/5 border-destructive/20 text-destructive"
                    )}>
                        {isConnected ? "live" : "offline"}
                    </span>
                </div>
            </div>

            {/* Right — player list toggle */}
            <Button
                variant="outline"
                size="sm"
                onClick={() => setIsPlayerListOpen(!isPlayerListOpen)}
                className={cn(
                    "h-7 text-[11px] font-semibold px-3 gap-1.5 rounded-lg border transition-all duration-200",
                    isPlayerListOpen
                        ? "bg-[#00ff66]/8 text-[#00ff66] border-[#00ff66]/25 shadow-[0_0_12px_rgba(0,255,102,0.08)]"
                        : "bg-white/[0.02] text-slate-400 border-white/[0.06] hover:border-[#00ffd1]/20 hover:text-[#00ffd1] hover:bg-[#00ffd1]/5"
                )}
            >
                <Users className="h-3.5 w-3.5" />
                <span>{playerCount.toLocaleString("en-US")} Online</span>
            </Button>
        </div>
    );
}
